import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UseMarkerEditLockResult } from 'features/geoEvents/hooks/useMarkerEditLock';

type MarkerEditControlsProps = {
  lock: UseMarkerEditLockResult;
};

export const MarkerEditControls = (
  props: MarkerEditControlsProps,
): JSX.Element | null => {
  const { lock } = props;
  const { t } = useTranslation();

  if (!lock.enabled) return null;

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        gap: 1,
        '& .MuiButton-root': {
          backgroundColor: theme.palette.button.surface.dark,
          boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
          color: theme.palette.button.surface.main,
          '&:hover': {
            backgroundColor: theme.palette.button.surface.light,
            boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
          },
        },
      })}
    >
      {lock.isLocked ? (
        <Button
          data-testid="marker-edit-controls-edit"
          onClick={lock.enterEditMode}
          size="medium"
          variant="contained"
        >
          {t('markerEditControls.editMarker')}
        </Button>
      ) : (
        <>
          <Button
            data-testid="marker-edit-controls-cancel"
            onClick={lock.cancel}
            size="medium"
            variant="contained"
          >
            {t('common.cancel')}
          </Button>
          {lock.hasStagedChange && (
            <Button
              data-testid="marker-edit-controls-update"
              onClick={lock.commit}
              size="medium"
              variant="contained"
            >
              {t('markerEditControls.update')}
            </Button>
          )}
        </>
      )}
    </Box>
  );
};
